import { get } from "lodash-es";
import bus from "vue3-eventbus";

import { checkIsMobile } from "@/utils/index";
import { openGoogleMap } from "@/utils/map";
import { initTheme } from "@/utils/theme";

import BookTipDialog from "../../views/hotel/Detail/components/itis/BookTipDialog.vue";
import { IChannelConfigs, IChannelTheme } from "../types";
import ITISBackToTop from "./components/Index/backToTop.vue";
import Promotion from "./components/Index/Promotion.vue";
import ITISFooter from "./components/Layout/Footer.vue";
const theme: IChannelTheme = {};

/** 点击rate预订时需要显示提示的酒店品牌 */
const SHOW_CUSTOM_DIALOG_BRAND_GROUP = [
  "617f99c32b7f08462afded45", // 安縵
  "61606b798dec39489e15193e" // dev 凯悦集团
];

export default {
  configs: {
    header: {
      logoAlign: "left"
    },
    currency: "TWD",
    useChannelLogo: true,
    logoUrl:
      "https://qiniu-uploads-cdn.charmdeer.com/FsP3SPw9sbo5IUeLbX2jJnD7yOfB_55.png",
    useChannelLanguages: true,
    showPrivateGender: false,
    components: {
      Footer: {
        component: ITISFooter, // 定制版 Footer
        props: {
          showCopyRight: false
        }
      },
      IndexBackToTop: {
        component: ITISBackToTop,
        props: {
          preventBtn: true
        }
      },
      IndexBeforeFeaturedHotels: {
        component: Promotion
      },
      BookTipDialog: {
        component: BookTipDialog
      }
    },
    pages: {
      Index: {
        logoUrl:
          "https://qiniu-uploads-cdn.charmdeer.com/FsP3SPw9sbo5IUeLbX2jJnD7yOfB_55.png",
        banners: {
          list: [
            {
              img: "https://qiniu-uploads-cdn.charmdeer.com/uploaded/lh6Z3QSSyQNO8JVnfO4tHK8U0_bK/itis-web.png"
            }
          ]
        },
        featuredHotels: [
          "5dc181c6e43c4744226356ea",
          "6756505e12134c242d6dc620",
          "5cd994953e7c2a45504f79d5"
        ],
        specialPromotions: {
          titleI18n: {
            zh_TW: "活動推薦",
            en: "Recommend Activity"
          },
          promotions: [
            {
              subtitleI18n: {
                zh_TW: "歡慶網站盛大揭幕，酒店贈禮等你來拿！",
                en: "Celebrating the grand unveiling of the website, hotel gifts await you!"
              },
              descriptionI18n: {
                zh_TW:
                  "為了給您更難忘的旅程體驗，我們與酒店攜手，為您的旅程帶來不一樣的禮遇。點擊下方「領取專屬禮遇」，即可查看合作酒店與專屬贈禮！",
                en: "To provide you with an unforgettable travel experience, we work closely with hotels to offer you a range of benefits. Click on 'Get Exclusive Benefits' below to view our partner hotels and the gifts they offer!"
              },
              buttonTextI18n: {
                zh_TW: "領取專屬禮遇",
                en: "Get Exclusive Benefits"
              },
              buttonLink: "https://www.itis.com.tw/limited.php",
              backgroundImage:
                "https://qiniu-uploads-cdn.charmdeer.com/uploaded/FkZVDcupEZ4uz4X2m-I0Wx55aZaz/ITIS_web_home_banner_0917.png"
            },
            {
              subtitleI18n: {
                zh_TW: "預訂即送！專屬網路折扣碼",
                en: "Book Now and Get an Exclusive Internet Discount Code!"
              },
              descriptionI18n: {
                zh_TW:
                  "出門旅行，網路不可少！立即在網站預訂，折扣碼將自動寄送到你手中，讓旅程從一開始就超值又順暢！",
                en: "Heading out on a trip? You can't go without the internet! Book directly on our website, and your discount code will be sent to you automatically, making your journey extra smooth and rewarding right from the start!"
              },
              buttonTextI18n: {
                zh_TW: "立即預訂",
                en: "Book Now"
              },
              buttonLink: "https://www.itis.com.tw/",
              backgroundImage:
                "https://qiniu-uploads-cdn.charmdeer.com/uploaded/Fn-Iq4TaaovqMQpuIGWGZ1eUJa5Q/%E4%BC%81%E4%B8%9A%E5%BE%AE%E4%BF%A1%E6%88%AA%E5%9B%BE_2a3b7186-f9c0-4ce6-b98d-c4f2ed63bd3e.png"
            }
          ]
        },
        rediscoverAsia: {
          loadHotels: false,
          hotelList: [
            {
              images: [
                "https://qiniu-uploads-cdn.charmdeer.com/FvrqyuM51TOitH3uKHiES5dBTwOu_5.jpg"
              ],
              nameI18n: {
                en: "Amankora",
                zh_TW: "Amankora"
              },
              descriptionI18n: {
                en: "Receive up to four complimentary nights for participation in culturally transformative experiences on a journey inspired by Bhutan's dedication to the happiness of its people. Discover the natural beauty and cultural richness of this last remaining Himalayan Buddhist Kingdom and reap the tangible and intangible rewards of giving back.",
                zh_TW:
                  "「快樂王國」、「幸福國度」之稱的不丹，擁有純樸的民風與純淨的自然，快樂不是因為富有，而是珍惜、滿足手邊的幸福。Amankora 是一把打開神秘不丹的鑰匙，由Aman精心安排旅程與餐宿，帶領貴賓體驗最真實、當地的不丹之旅。"
              },
              externalLink: "https://www.itis.com.tw/limited_detail.php?id=62"
            },
            {
              images: [
                "https://qiniu-uploads-cdn.charmdeer.com/Ft1sMGZ_rXWC40H1cAkzbjWpRUeg_5.jpg"
              ],
              nameI18n: {
                en: "Amanjiwo",
                zh_TW: "Amanjiwo"
              },
              descriptionI18n: {
                en: "On stepping into the lounge at Jakarta-Gambir Station, a warm Javanese welcome begins. Throughout the journey guests will enjoy breath-taking views of the Javanese countryside to Yogyakarta.<br />Amanjiwo will provide the catering and the resort's resident anthropologist will share his insights on the historical sites of the Javanese countryside. Guests will arrive at Amanjiwo after a seven-hour journey.",
                zh_TW:
                  "踏上私人列車車廂的一刻，Aman 之旅便啟程了，享受火車上Amanjiwo精心準備的餐點，人類學家為您導覽沿途經過的歷史遺跡，這是抵達婆羅浮屠的最佳方式。"
              },
              externalLink: "https://www.itis.com.tw/limited_detail.php?id=63"
            }
          ]
        }
      },
      prepareOrder: {
        showCancellationPopover: true
      },
      auth: {
        showInvitationCode: true
      }
    },
    footer: {
      show: true
    },
    seo: {
      title: "ITIS唯客樂旅行社 | 奢華旅遊訂房、訂製、客製化",
      description:
        "隨時開啟你的假期！一鍵訂房，快速又方便。專業旅遊顧問提供量身打造的客製化旅遊規劃，讓每一趟旅程都享有專屬的極致體驗！",
      keywords:
        "唯客樂旅行社,ITIS,itis,奢華旅遊,出國旅遊,台灣旅遊,訂製旅遊,客製化旅遊,自由行"
    }
  },
  init() {
    if (checkIsMobile()) {
      window.location.href = "https://itis-m.ytripos.com/";
      return;
    }
    initTheme(theme);
  },
  openLocation({ address }) {
    openGoogleMap({
      address
    });
  },
  beforeHotelBook({ hotel, rate }) {
    return new Promise((resolve, reject) => {
      const groupId = get(hotel, "brand.group._id");
      if (SHOW_CUSTOM_DIALOG_BRAND_GROUP.includes(groupId)) {
        bus.emit("showBookTipDialog", { rate });
        reject();
      } else {
        resolve(true);
      }
    });
  }
} as IChannelConfigs;
